
import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateBalance = (params) => {
    return axios.post(`${backendHost}/api/admin/balance`, params);
};

export {
    postUpdateBalance
}